export const FORM_CONTROL_TYPES = {
  SELECT: 'select',
  DATEPICKER: 'datepicker',
  MULTISELECT: 'multiselect'
}
